import { MERGE_TAG_DRAG_TYPE } from "./constants"

export type MergeTagDragPayload = {
  nodeKey: string | null
  tagId: string
  tagLabel: string
}

let activeDrag: MergeTagDragPayload | null = null

export const setActiveMergeTagDrag = (payload: MergeTagDragPayload): void => {
  activeDrag = payload
}

export const getActiveMergeTagDrag = (): MergeTagDragPayload | null => activeDrag

export const clearActiveMergeTagDrag = (): void => {
  activeDrag = null
}

export const parseMergeTagDragPayload = (
  dataTransfer: DataTransfer | null,
): MergeTagDragPayload | null => {
  const fromStore = getActiveMergeTagDrag()
  const raw = dataTransfer?.getData(MERGE_TAG_DRAG_TYPE)
  let fromData: MergeTagDragPayload | null = null

  if (raw) {
    try {
      fromData = JSON.parse(raw) as MergeTagDragPayload
    } catch {
      fromData = null
    }
  }

  // In-memory store is authoritative for moves (reorder existing pills).
  if (fromStore?.nodeKey) {
    return fromStore
  }

  return fromData ?? fromStore
}
